import React from 'react';

const ProfileThumbnail = ({image}) => 
    <img src={image} width={281} style={profileStyle} />

const profileStyle = {
    margin: 0,
    WebkitBorderRadius: '15px',
    MozBorderRadius: '15px',
    borderRadius: '15px'
};

export default ProfileThumbnail;


// WEBPACK FOOTER //
// ./src/components/ProfileThumbnail.js